import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import AUTH_CONFIG from '../common/configurations/AuthConfig';
import AppConstants from '../common/constants/AppConstants';
import ApiService from './ApiService';

let userGroups = AppConstants?.appInsights?.userGroups
  ? AppConstants.appInsights.userGroups
  : [];
const stage =
  process.env.REACT_APP_STAGE !== undefined
    ? process.env.REACT_APP_STAGE
    : 'local';
const { instrumentationKey } = AUTH_CONFIG[stage].settings;

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey,
    extensions: [reactPlugin],
    enableCorsCorrelation: true,
  },
});
let userProfile;

const getUserDetails = () => {
  for (let i = 0; i < window.sessionStorage.length; i += 1) {
    const key = window.sessionStorage.key(i);
    if (key.slice(0, 9) === 'oidc.user') {
      return JSON.parse(window.sessionStorage.getItem(key)).profile;
    }
  }
  return null;
};

const getRoleDetails = (profileGroups) => {
  let filteredGroup = null;
  profileGroups.forEach((grp) => {
    const groupDetails = userGroups.filter(
      (itemGrp) => itemGrp.group.toLowerCase() === grp.toLowerCase(),
    );
    if (groupDetails.length > 0) [filteredGroup] = groupDetails;
  });

  if (filteredGroup) return filteredGroup;
  return { group: '', site: '', role: '', persona: '' };
};

const extractUpdateUserProfile = () => {
  let groups = [];
  if (userProfile) {
    const profileProps = Object.keys(userProfile).map((item) =>
      item.toLowerCase(),
    );
    if (profileProps.includes('idp')) {
      // indicates authentication thru Digital P@ss, then get email id and name
      let mailId = '';
      if (profileProps.includes('otherMails'.toLowerCase())) {
        mailId =
          userProfile.otherMails.length > 0 ? userProfile.otherMails[0] : '';
      }
      userProfile = { ...userProfile, email: mailId };
      // group
      if (
        profileProps.includes('groupes'.toLowerCase()) &&
        userProfile.groupes.length > 0
      )
        groups = userProfile.groupes;
    } else {
      userProfile.name = profileProps.includes(
        'signInNames.emailAddress'.toLowerCase(),
      )
        ? userProfile['signInNames.emailAddress']
        : userProfile.name;
      userProfile = { ...userProfile, email: userProfile.name };
      // group
      if (
        profileProps.includes('groups'.toLowerCase()) &&
        userProfile.groups.length > 0
      ) {
        groups = userProfile.groups;
      }
    }
  }
  return groups;
};

const updateAppInsightUserInfo = () => {
  const groups = extractUpdateUserProfile();
  // get Site and Role from groups ID
  let userRole = { group: '', site: '', role: '', persona: '' };
  if (groups.length > 0) userRole = getRoleDetails(groups);

  userProfile = { ...userProfile, role: userRole };
  appInsights.setAuthenticatedUserContext(userProfile.name);
  appInsights.context.user.id = `${userProfile?.given_name} ${userProfile?.family_name}`;
};

const assignUserInfoToAppInsights = () => {
  userProfile = getUserDetails();

  if (userProfile) {
    ApiService.getAllGroups()
      .then((response) => {
        userGroups = response.data;
        updateAppInsightUserInfo();
      })
      .catch(() => {
        userGroups = [];
        updateAppInsightUserInfo();
      });
  }
};

appInsights.loadAppInsights();
assignUserInfoToAppInsights();
const userDetails = userProfile;
export { reactPlugin, appInsights, userDetails };
